<script>
import '../assets/tailwind.css';
import NavigatorBar from './NavigatorBar.vue';

export default {
  
}
</script>

<template>
  <NavigatorBar/>
  <br><br><br><br><br><br><br><br><br>
  <h3>Thanks for checking out Glitch Garden!</h3>
  <a href="https://github.com/rochelletham/glitchgarden">
    <h4 class="text-body">Github repo: https://github.com/rochelletham/glitchgarden</h4>
  </a> 
  <br><br>
  <h4>Feel free to send questions or comments here: rochelle@ccrma.stanford.edu</h4>
  <br><br><br><br>
  <h4>Demo will be available on Friday 11/21/2025 at the Web Audio Conference.</h4>
  <br><br><br><br>
  <h2>About GlitchGarden</h2>
  <h2>More to come...</h2>
</template>
